// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Wgs3","buttons":"RemoveExpirationActionButtons_buttons__3uNoU"};